// extracted by mini-css-extract-plugin
export default {"partnersFiltersContainer":"partnersFilters_partnersFiltersContainer__B-ksJ","collapsableComponent":"partnersFilters_collapsableComponent__r-PUJ"};